import AppShell from "../shell/AppShell.jsx";

import PageSkeleton from "../components/Skeleton.jsx";
const FORBIDDEN_TITLE = "หน้านี้ใช้ได้เฉพาะ Agent เจ้าของสายงาน";
const DEFAULT_FORBIDDEN_BODY =
  "บัญชีของคุณไม่มีสิทธิ์ Agent เจ้าของสายงานใด หน้านี้ใช้ได้เฉพาะ Agent เจ้าของสายงานเท่านั้น SuperAdmin, Super Agent และ PLC ดูข้อมูลนี้ได้จากผังสายงานแทน";

/**
 * Shared loading/error/forbidden states for every Agent Portal page
 * (Prompt 138) - mirrors AgentInviteCardsPage.jsx's own early-return blocks
 * (Prompt 090) verbatim, factored out so six more pages don't each
 * reimplement the same three &lt;AppShell&gt; states. Returns null when the
 * guard is "ready" - the caller continues on to its own real content in
 * that case; every other status returns a full page in place of that
 * content.
 */
export default function AgentPortalGuardState({ crumbs, guard, forbiddenBody }) {
  if (guard.status === "loading") {
    return (
      <AppShell crumbs={crumbs}>
        <PageSkeleton variant="table" toolbar={false} label="กำลังโหลดข้อมูลผู้ใช้งาน..." />
      </AppShell>
    );
  }

  if (guard.status === "error") {
    return (
      <AppShell crumbs={crumbs}>
        <div className="wx-state-card wx-state-card--danger" role="alert">
          <h1 className="wx-state-title">ไม่สามารถโหลดข้อมูลผู้ใช้งานได้</h1>
          <p className="wx-state-body">
            {guard.error?.status === 401 ? "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่" : "กรุณาลองรีเฟรชหน้านี้อีกครั้ง หากยังพบปัญหากรุณาติดต่อฝ่ายปฏิบัติการ"}
          </p>
        </div>
      </AppShell>
    );
  }

  if (guard.status === "forbidden") {
    return (
      <AppShell crumbs={crumbs}>
        <div className="wx-state-card wx-state-card--danger" role="alert">
          <h1 className="wx-state-title">{FORBIDDEN_TITLE}</h1>
          <p className="wx-state-body">{forbiddenBody ?? DEFAULT_FORBIDDEN_BODY}</p>
        </div>
      </AppShell>
    );
  }

  return null;
}
